<template>
  <div>
    <div class="container_top_img">
      <img src="../../assets/img/new/communityTopBanner.png" alt="社区生态头部展示图">
    </div>
    <div class="my_container">
      <!-- 专家学者会客厅 -->
      <div class="glag_left reception_box">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>专家学者会客厅</span>
            <router-link class="rt" :to="{ path: '/receptionLiveList', query: { nav: 5 } }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
        </div>
        <div class="reception_expert_box" @click="allJump(expertList.type, expertList.list_id, 5, expertList.is_doing)">
          <div class="video_box_shadow">
            <i class="my_icon_list player_icon_big"></i>
          </div>
          <img :src="expertList.img" alt="专家学者封面" :onerror="defaultImg">
          <div v-if="expertList.is_doing === 0 || expertList.is_doing === 1" class="reception_expert_state">
            <i v-if="expertList.is_doing === 1" class="my_icon_list live_state_icon"></i>
            <span v-if="expertList.is_doing === 0" class="lf">预告</span>
            <span v-if="expertList.is_doing === 1" class="lf">直播中</span>
            <p v-if="expertList.is_doing === 0" class="lf">
              <i class="reception_expert_state_num">{{expertList.sign_count}}</i>
              报名
            </p>
            <p v-if="expertList.is_doing === 1" class="rt">
              <i class="reception_expert_state_num">{{expertList.read}}</i>
              观看
            </p>
          </div>
          <div class="reception_expert_info">
            <p class="reception_expert_title lf">{{expertList.title}}</p>
            <!-- <p class="reception_expert_user lf">主讲人: {{expertList.user_name}}</p> -->
            <p  v-if="expertList.is_doing === 0" class="reception_expert_btn">前往报名</p>
            <p  v-if="expertList.is_doing === 1" class="reception_expert_btn">进入直播间</p>
          </div>
        </div>
        <ul class="reception_ul">
          <li class="reception_li_live lf">
            <div class="title_top_hr">
              <p>
                <span>行业精英工作室</span>
                <router-link class="rt" :to="{ path: '/receptionLiveList', query: { nav: 6 } }" ><u class="iconfont icon-gengduo"></u></router-link>
              </p>
            </div>
            <!-- <div class="reception_li_live_box" @click="allJump(industryList.type, industryList.list_id, 6, industryList.is_doing)"> -->
            <div class="reception_li_live_box" @click="priceJump(industryList.type, industryList.list_id, 6, industryList.is_doing)">
              <div class="reception_li_live_top">
                <img :src="industryList.img" alt="封面" :onerror="defaultImg">
                <div class="reception_li_live_state">
                  <div v-if="industryList.is_doing === 0" class="reception_li_live_time">
                    {{mycommon.judgeDate(industryList.start_time)}}
                  </div>
                  <div v-if="industryList.is_doing === 1" class="reception_li_live_start">
                     <i class="my_icon_list live_state_icon"></i>
                     <span>直播中</span>
                  </div>
                </div>
              </div>
              <div class="reception_li_live_bottom">
                <p class="reception_li_live_title">
                  <i v-if="industryList.is_buy !== 0">已购买</i>
                  <i v-if="industryList.is_doing === 0">即将开始</i>
                  <i v-if="industryList.is_doing === 1">直播中</i>
                  {{industryList.title}}
                </p>
                <p class="reception_li_live_info">
                  主讲人：{{industryList.user_name}}
                  <span class="rt">￥<i style="font-size: 16px; color: #AB7D11">{{industryList.price}}</i></span>
                </p>
                <p  class="reception_li_live_other">
                  <span v-if="industryList.is_doing === 0"><i class="font_i">{{industryList.sign_count}}</i> 报名</span>
                  <span v-if="industryList.is_doing === 1"><i class="font_i">{{industryList.read}}</i> 观看</span>
                </p>
              </div>
            </div>
          </li>
          <li class="reception_li_live lf">
            <div class="title_top_hr">
              <p>
                <span>专业精英工作室</span>
                <router-link class="rt" :to="{ path: '/receptionLiveList', query: { nav: 7 } }" ><u class="iconfont icon-gengduo"></u></router-link>
              </p>
            </div>
            <div class="reception_li_live_box"  @click="allJump(majorList.type, majorList.list_id, 7, majorList.is_doing)">
              <div class="reception_li_live_top">
                <img :src="majorList.img" alt="封面" :onerror="defaultImg">
                <div class="reception_li_live_state">
                  <div v-if="majorList.is_doing === 0" class="reception_li_live_time">
                    {{mycommon.judgeDate(majorList.start_time)}}
                  </div>
                  <div v-if="majorList.is_doing === 1" class="reception_li_live_start">
                    <i class="my_icon_list live_state_icon"></i>
                    <span>直播中</span>
                  </div>
                </div>
              </div>
              <div class="reception_li_live_bottom">
                <p class="reception_li_live_title">
                  <i v-if="majorList.is_doing === 0">即将开始</i>
                  <i v-if="majorList.is_doing === 1">直播中</i>
                  {{majorList.title}}
                </p>
                <p class="reception_li_live_info">
                  主讲人：{{majorList.user_name}}
                </p>
                <p class="reception_li_live_other">
                  <span v-if="majorList.is_doing === 0"><i class="font_i">{{majorList.sign_count}}</i> 报名</span>
                  <span v-if="majorList.is_doing === 1"><i class="font_i">{{majorList.read}}</i> 观看</span>
                </p>
              </div>
            </div>
          </li>
          <li class="reception_li_member lf">
            <div class="title_top_hr">
              <p>
                <span>社区交流室</span>
                <router-link class="rt" :to="{ name: 'MemberList' }" ><u class="iconfont icon-gengduo"></u></router-link>
              </p>
            </div>
            <div v-for="item in membersList" :key="item.id" class="reception_li_member_item">
              <div class="reception_li_member_info">
                <p class="reception_li_member_pic">
                  <img :src="item.portrait" alt="用户头像">
                </p>
                <dl>
                  <dt>
                    <a @click = "userJump(item.user_id)">{{item.user_name}}</a>
                  </dt>
                  <dd>
                    <span>{{item.comment_count}}讨论</span>
                    {{item.add_time}}
                  </dd>
                </dl>
              </div>
              <p class="reception_li_member_title" @click="allJump(item.type, item.list_id, 8)">
                {{item.title}}
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 热搜 -->
      <div class="glag_right community_hot_search_box">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>热搜</span>
            <router-link class="rt" :to="{ path: '/conciseList', query: { nav: 1, type: 'hot' } }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
          <el-divider></el-divider>
        </div>
        <ul class="community_hot_search_ul">
          <li v-for="(item, index) in hotList" :key="item.id" class="community_hot_search_item">
            <a @click="allJump(item.type, item.list_id, item.nav_id, item.is_doing)">
              <i v-if="index === 0" class="first_label">{{index + 1}}</i>
              <i v-if="index === 1" class="two_label">{{index + 1}}</i>
              <i v-if="index === 2" class="three_label">{{index + 1}}</i>
              <i v-if="index > 2" class="glay_label">{{index + 1}}</i>
              {{item.title}}
            </a>
          </li>
        </ul>
      </div>
      <!-- 活跃会员 -->
      <div class="glag_right community_actively_user_box">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>活跃会员</span>
            <router-link class="rt" :to="{ name: 'ActiveUserList' }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
          <el-divider></el-divider>
        </div>
        <ul class="community_actively_user_ul">
          <li v-for="(item, index) in usersList" :key="item.id" class="community_actively_user_item">
            <p class="community_actively_user_pic">
              <img :src="item.portrait" alt="头像">
            </p>
            <dl class="community_actively_user_info">
              <dt><a @click = "userJump(item.id)">{{item.user_name}}</a></dt>
              <dd>
                <span>{{item.fans_count}}人关注</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{item.live_count}}次直播</span>
              </dd>
            </dl>
            <div class="community_actively_user_btn">
              <button v-if="item.is_follow === 0" class="greenglga_follow_btn" @click="followBtn(item.id, index)">关注</button>
              <button v-if="item.is_follow === 1" class="greenglga_follow_btn greenglga_follow_btn_confirm" @click="followBtn(item.id, index)">已关注</button>
            </div>
          </li>
        </ul>
      </div>
      <!-- 广告 -->
      <div class="glag_all m_t_30">
        <img src="../../assets/img/research/banner.jpg" alt="横幅">
      </div>
      <!-- 推荐 -->
      <div class="glag_left">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>推荐</span>
            <router-link class="rt" :to="{ path: '/conciseList', query: { nav: 1, type: 'recommend' } }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
          <el-divider></el-divider>
        </div>
        <ul class="community_recommend_box">
          <li v-for="item in recommendList" :key="item.id" class="community_recommend_item">
            <p v-if="item.img!== ''" class="community_recommend_left pointer_hover"  @click="allJump(item.type, item.list_id, item.nav_id, item.isDoing)">
              <i v-if="item.type !== 3" class="my_icon_list player_icon"></i>
              <img :src="item.img" alt="封面">
            </p>
            <div :class="item.img !== '' ? 'community_recommend_content community_recommend_right' : 'community_recommend_content'">
              <p class="community_recommend_title"  @click="allJump(item.type, item.list_id, item.nav_id, item.isDoing)">
                {{item.title}}
              </p>
              <p class="community_recommend_text" @click="allJump(item.type, item.list_id, item.nav_id, item.isDoing)">
                 {{item.content}}
              </p>
              <div class="community_recommend_foot">
                <div class="community_recommend_foot_lf lf">
                  <img :src="item.portrait" alt="头像">
                  <a>{{item.user_name}}</a>
                  <span>{{item.add_time}}</span>
                </div>
                <div class="community_recommend_foot_rt rt">
                  <el-breadcrumb v-if="item.type === 1 && item.is_dong === 0" separator="|">
                    <el-breadcrumb-item class="my_icon_box r_border"><a><i class="my_icon shoucang"></i><span class="my_icon_text">{{item.favorites}} 预约观看</span></a></el-breadcrumb-item>
                    <el-breadcrumb-item></el-breadcrumb-item>
                  </el-breadcrumb>
                  <el-breadcrumb v-else-if="item.type === 1 && item.is_dong === 1" separator="|">
                    <el-breadcrumb-item class="my_icon_box r_border"><a><i class="my_icon shoucang"></i><span class="my_icon_text">{{item.favorites}} 观众</span></a></el-breadcrumb-item>
                    <el-breadcrumb-item></el-breadcrumb-item>
                  </el-breadcrumb>
                  <el-breadcrumb v-else separator="|">
                    <el-breadcrumb-item class="my_icon_box"><a><i class="my_icon dianzan"></i><span class="my_icon_text">点赞 {{item.like}}</span></a></el-breadcrumb-item>
                    <el-breadcrumb-item class="my_icon_box r_border"><a><i class="my_icon shoucang"></i><span class="my_icon_text">收藏 {{item.favorites}}</span></a></el-breadcrumb-item>
                    <el-breadcrumb-item></el-breadcrumb-item>
                  </el-breadcrumb>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 圈子 -->
      <div class="glag_right">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>圈子</span>
            <router-link class="rt" :to="{ path: '/circleList', query: { type: 'community' } }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
          <el-divider></el-divider>
        </div>
        <ul class="community_circle_box">
          <li v-for="item in boardList" :key="item.id" class="community_circle_item" @click="boardJump(item.board_id)">
            <div class="community_circle_item_left">
              <img :src="item.pic" alt="封面">
            </div>
            <dl class="community_circle_item_right">
              <dt>{{item.board_name}}</dt>
              <dd>
                {{item.user_name}} ｜ {{item.numbers}} 名成员
              </dd>
            </dl>
            <p class="community_circle_item_btn">
              <button v-if="item.is_join === 0" class="greenglga_follow_btn">加入</button>
              <button v-else class="greenglga_follow_btn greenglga_follow_btn_confirm">已加入</button>
            </p>
          </li>
        </ul>
      </div>
      <!-- 专家观点 -->
      <div class="glag_left">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>专家观点</span>
            <router-link class="rt" :to="{ name: 'ExpertList' }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
          <el-divider></el-divider>
        </div>
        <ul class="community_expert_box">
          <li v-for="(item, index) in viewpointList" :key="item.id" class="community_expert_item" @mouseover="viewpointIndex = index">
            <div v-if = "index === viewpointIndex">
              <div class="community_expert_detail">
                <div class="community_expert_detail_left">
                  <img :src="item.head" alt="头像">
                </div>
                <div class="community_expert_detail_right">
                  <p class="community_expert_detail_title" @click="allJump(3, item.list_id, 9)">{{item.title}}</p>
                  <p class="community_expert_detail_user">
                    <span>{{item.expert_name}}</span>
                  </p>
                  <p class="community_expert_detail_content" @click="allJump(3, item.list_id, 9)">
                    {{item.content}}
                  </p>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="community_expert_link">
                <i class="community_expert_link_disc"></i>
                <span class="community_expert_link_title">{{item.expert_name}}： </span>
                <span class="community_expert_link_content">
                  {{item.title}}
                </span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 视频 -->
      <div class="glag_right">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>视频</span>
            <router-link class="rt" :to="{ name: 'CommunityVideoList' }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
          <el-divider></el-divider>
        </div>
        <ul class="community_video_box">
          <li v-for="item in videosList" :key="item.id" class="community_video_item" @click="communityJump(item.list_id, item.nav_id)">
            <i class="my_icon_list player_icon"></i>
            <img :src="item.img" alt="封面">
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      defaultImg: 'this.src="' + require('../../assets/img/other/imgError.png') + '"',
      expertList: {}, // 专家学者会客厅
      industryList: {}, // 行业精英工作室
      majorList: {}, // 专业经营工作室
      membersList: [], // 社区成员列表
      hotList: [], // 热搜列表
      usersList: [], // 活跃会员
      recommendList: [], // 推荐列表
      boardList: [], // 圈子列表
      viewpointList: [], // 专家观点
      viewpointIndex: 0, // 当前选中专家观点
      videosList: [] // 视频列表
    }
  },
  created () {
    // 获取信息
    this.getInfo()
  },
  methods: {
    // 获取页面信息
    getInfo () {
      const vueThat = this
      vueThat.myApi.communityIndex().then((res) => {
        if (res.data.code === 200) {
          vueThat.expertList = res.data.data.expert
          vueThat.industryList = res.data.data.industry
          vueThat.majorList = res.data.data.major
          vueThat.membersList = res.data.data.members
          vueThat.hotList = res.data.data.hot
          vueThat.usersList = res.data.data.users
          vueThat.recommendList = res.data.data.recommend
          vueThat.boardList = res.data.data.board_list
          vueThat.viewpointList = res.data.data.viewpoint
          vueThat.videosList = res.data.data.videos_list
        }
      })
    },
    // 页面跳转
    communityJump (listId, navId, isDoing) {
      this.mycommon.detailJump(this, listId, navId, isDoing)
    },
    priceJump (type, listId, isDoing) {
      if (this.industryList.is_buy === 0 && this.industryList.price !== '0.00') {
        this.$alert('本视频为付费视频，请您下载APP，完成支付！', '温馨提示', {
          type: 'error',
          confirmButtonText: '下载APP',
          showClose: true
        }).then(() => {
          const routeData = this.$router.resolve({
            path: '/down'
          })
          window.open(routeData.href, '_blank')
        })
      } else {
        this.allJump(type, listId, isDoing)
      }
    },
    // 详情跳转
    allJump (type, listId, navId, isDoing) {
      console.log(type)
      this.mycommon.allJump(this, type, listId, navId, isDoing)
    },
    // 添加关注
    followBtn (uid, index) {
      const vueThat = this
      const follow = vueThat.usersList[index].is_follow
      if (follow === 0) {
        vueThat.myApi.addFollow({ user_id: uid }).then((res) => {
          if (res.data.code === 200) {
            // vueThat.$message({
            //   message: '关注成功',
            //   type: 'success'
            // })
            vueThat.usersList[index].is_follow = 1
            vueThat.usersList[index].fans_count += 1
          }
        })
      } else {
        vueThat.myApi.cancelFollow({ user_id: uid }).then((res) => {
          if (res.data.code === 200) {
            // vueThat.$message({
            //   message: '取消关注',
            //   type: 'success'
            // })
            vueThat.usersList[index].is_follow = 0
            vueThat.usersList[index].fans_count -= 1
          }
        })
      }
    },
    // 个人中心跳转
    userJump (rid) {
      this.mycommon.userJump(this, rid)
    },
    // 圈子帖子列表跳转
    boardJump (rid) {
      const routeData = this.$router.resolve({
        path: '/cirlePostList/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped="scoped">
  .container_top_img{
    width: 100%;
    min-width: 1100px;
    height: auto;
    margin-top: -30px;
  }
</style>
